import { useEffect, useRef, useState } from "react";
import './home.css'
import splash from '../images/splash-photo.jpeg';

export const PASSWORD: string = process.env.REACT_APP_PASSWORD ?? "";

function Home() {

   const passwordRef = useRef("")
   const [isLoggedIn, setIsLoggedIn] = useState(false)
   const WEDDING_DATE = new Date("January 17, 2027 00:00:00 EST").getTime();
   const [time, setTime] = useState(WEDDING_DATE - Date.now())

   useEffect(() => {
      if (isLoggedIn) {
         const interval = setInterval(() => {
            setTime(WEDDING_DATE - Date.now())
         }, 60*60*1000)

         return () => clearInterval(interval);
      }
   })


   function currentTime() {

      return (
         <p className="Countdown-time">{`${Math.floor(time / (24 * 60 * 60 * 1000))} days until we say "I do!"`}</p>
      )
   }

   function handleSubmit() {
      if (passwordRef.current === PASSWORD) {
         window.sessionStorage.setItem("loggedIn", "TRUE")
         setIsLoggedIn(true)
      }
   }

   const handleKeyDown = (event: any) => {
      if (event.keyCode === 13) {
         event.preventDefault();
         handleSubmit()
      }
   }

   if (window.sessionStorage.getItem("loggedIn") === "TRUE" && !isLoggedIn) {
      setIsLoggedIn(true)
   }

   function LoginForm() {
      return (
         <div className="Login-page">
            <input className="Password-input" type="text" id="password" name="password" placeholder="Enter password here..." autoCapitalize="none" onChange={(e) => passwordRef.current = e.target.value} onKeyDown={(handleKeyDown)} />
            <input className="Login-prompt" type="submit" value="Submit" onClick={(handleSubmit)} />
            <p className="Login-prompt">
               Find the password on the save-the-date you received!</p>
         </div>)
   }

   function HomePage() {
      return (
         <>
            <img src={splash} className="Splash-image" alt="From engagement shoot of Nick and Kruthi"></img>
            <p className="Home-name-text">Kruthi Annigeri and Nicholas LaBelle</p>
            {currentTime()}
         </>
      )
   }



   return (
      isLoggedIn ? <HomePage /> : <LoginForm />
   )
}

export default Home;